import { TypeActionProductionInfo, } from "../../info/production/actionProductionInfo";
import { IdTutorialFocusElement } from "../IdTutorialFocusElement";
import { IdTutorialStep } from "../IdTutorialStep";
import { selectTutorialConfigData } from "../selectors/selectTutorialConfigData";
export var checkTutorialQuestClickQuestMenu = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var _a = selectTutorialConfigData(state), tutorialStepConfig = _a.tutorialStepConfig, nextTutorialStepConfig = _a.nextTutorialStepConfig;
    var isNewQuestClickQuestMenu = tutorialStepConfig.nextStep === IdTutorialStep.checkNewQuest_clickQuestMenu &&
        action.type === TypeActionProductionInfo.Collect;
    var isCollectQuestClickQuestMenu = tutorialStepConfig.nextStep === IdTutorialStep.collectQuestReward_clickQuestMenu &&
        action.type === TypeActionProductionInfo.Start;
    if (!isNewQuestClickQuestMenu && !isCollectQuestClickQuestMenu) {
        return undefined;
    }
    if (nextTutorialStepConfig.focusId == undefined) {
        return undefined;
    }
    if (nextTutorialStepConfig.focusId !== IdTutorialFocusElement.hud_quest_7) {
        return undefined;
    }
    return path;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/checks/checkTutorialQuestClickQuestMenu.ts
// module id = 906
// module chunks = 3